import { Component, ViewChild } from '@angular/core';
import { ComboService } from '../../../Model/Combo/combo.service';
import { SessionService } from '../../../Util/Session/session.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModal, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { SiteGeoMappingService } from '../../../Model/LocationMaster/SiteGeoMappng/site-geo-mapping.service';
import { Subject } from 'rxjs';
import { SiteUserService } from '../../../Model/SiteUser/site-user.service';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-site-user',
  standalone: true,
  imports: [DataTablesModule, CommonModule, FormsModule, NgbNavModule, NgSelectModule, RouterModule, LoaderComponent],
  templateUrl: './site-user.component.html',
  styleUrl: './site-user.component.scss'
})
export class SiteUserComponent {
  isDisabled: boolean = false;
  TableDatas: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;

  Filter = {
    Type: 'SiteUserCreation',
    BranchId: null,
    ClientID: null,
    SiteID: null,
    UserId: null,
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    private combo: ComboService,
    private session: SessionService,
    private sitegeomapping: SiteGeoMappingService,
    private siteuser: SiteUserService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip: TooltipService,
    private toast: ToastService,
  ) {
    this.Filter.UserId = this.session.GetUserDetails().UserId;
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
    this.common.CheckExpiry();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any) {
    if (form.valid) {
      this.SiteGeoMapLoad();
    }
    else {
      form.submitted = true;
    }
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype == 'Branch') {
      this.Branchs = [];
      this.Clients = [];
      this.Sites = [];

      this.Filter.BranchId = null
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
    } else if (Combotype == 'Client') {
      this.Clients = [];
      this.Sites = [];
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
    } else if (Combotype == 'Site') {
      this.Sites = [];
      this.Filter.SiteID = null;
    }

    this.combo.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.Filter.BranchId : 0,
      'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.Filter.ClientID : 0,
      'SiteId': 0,
      'DesignationId': 0,
      'EmpType': this.session.GetUserDetails().EmpType,
      'StateId': 0,
      'DistrictId': 0,
      'EmpMasterID': this.session.GetUserDetails().UserId
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.Branchs = response.ComboLoad;
        } else if (Combotype == 'Client') {
          this.Clients = response.ComboLoad;
        } else if (Combotype == 'Site') {
          this.Sites = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SiteGeoMapLoad() {
    this.isDisabled = true;
    this.sitegeomapping.SiteGeoMapLoad(this.Filter).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  SUCheck(event: any, i: number, IsAll = false) {
    if (IsAll) {
      this.TableDatas.forEach((e: any) => {
        if (!e.IsSiteUserCreation) {
          e.checked = event.target.checked;
        }
      });
    } else {
      this.TableDatas[i].checked = event.target.checked;
    }
  }
  
 async save() {
    await this.common.getPageRights();
    if (this.TableDatas.filter((e: any) => e.checked).length <= 0) {
      const modalRef = this.modalService.open(AlertWarningComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'No sites selected. Please select at least one site to proceed.';
      modalRef.result.then((result: any) => { });
      return;
    }
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to save?'
    modalRef.result.then((result: any) => {
       if (this.common.PageRight.IsEdit || this.common.PageRight.IsAdd) {
      if (result) {
        this.Submit();
      }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {

    });
  }

  Submit() {
    //const checkedSiteIds = this.TableDatas.filter(row => row.checked).map(row => row.SiteID);
    const checkedSiteIds = this.TableDatas.filter(row => row.checked && !row.IsSiteUserCreation).map(row => row.SiteID);
    const siteIds  = checkedSiteIds.join(',');
    this.siteuser.ESS_SiteUser({ SelectType: 'U', SiteIds: siteIds, UserId: this.Filter.UserId }).subscribe({
      next: (response) => {
        if (response.Error_Code == '515') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.SiteGeoMapLoad();
            }
          });
        }
        else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  change(){
    this.TableDatas = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
}
